const module = { name: 'shared/global/carousels/caligariCarousel', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { default as swipe } from 'swug-fdRequire-call:shared/global/jcarousel.swipe';



const Selectors = {
    LINK: '.js-caligari-link',
    LIST: '.js-caligari-list',
    LIST_ITEM: '.js-caligari-item',
    LEFT_BTN: '.js-caligari-flipper-left',
    RIGHT_BTN: '.js-caligari-flipper-right',
}


const Events = {
    CREATE: 'jcarousel:create',
    RELOAD: 'jcarousel:reload',
    VISIBLE_IN: 'jcarousel:visiblein',
    VISIBLE_OUT: 'jcarousel:visibleout',
}
function onVisibleIn() {
    $(this).find(Selectors.LINK).attr('tabindex', 0);
}
function onVisibleOut() {
    $(this).find(Selectors.LINK).attr('tabindex', -1);
}
function onReload() {
    const $this = $(this);
    const width = $this.innerWidth();
    const $items = $(Selectors.LIST, $this).children();
    $this.jcarousel('list').width($items.length * width);
}
function init(id, opts) {
    swipe.init();
    const $carousel = $(`#${id}`);
    if (!$carousel.length) {
        return null;
    }
    opts = Object.assign({
        swipeScrollBy: 2,
        buttonScrollBy: 3,
    }, opts);
    const carousel = $carousel
        .on(`${Events.CREATE} ${Events.RELOAD}`, onReload)
        .on(Events.VISIBLE_IN, Selectors.LIST_ITEM, onVisibleIn)
        .on(Events.VISIBLE_OUT, Selectors.LIST_ITEM, onVisibleOut)
        .jcarousel({
        animation: {
            duration: 700
        },
        wrap: 'circular'
    })
        .jcarouselSwipe({
        next: `+=${opts.swipeScrollBy}`,
        prev: `-=${opts.swipeScrollBy}`
    })
        .data('jcarousel');
    $carousel.jcarousel('visible').each(function () {
        $(this).trigger(Events.VISIBLE_IN);
    });
    $(Selectors.LEFT_BTN, $carousel).on('click', () => carousel.scroll(`-=${opts.buttonScrollBy}`));
    $(Selectors.RIGHT_BTN, $carousel).on('click', () => carousel.scroll(`+=${opts.buttonScrollBy}`));
    return carousel;
}
module.exports = {
    init,
};
export default module.exports;